export function deduplicateBy<T>(values: Iterable<T>, getKey: (value: T) => string): T[] {
    const valuesByKey = new Map<string, T>()

    for (const value of values) {
        valuesByKey.set(getKey(value), value)
    }

    return [...valuesByKey.values()]
}
